const zh = {
	download: '下载结算报表',
	filter: {
		webSite: '网站',
		all: '全部',
		groupName: '群组',
		transactionId: '交易流水号',
		orderId: '网站订单号',
		date: '时间',
		selectDate: '选择日期',
		quicklySelect: {
			lab: '快速选择',
			range: {
				today: '今天',
				lastWeek: '最近一周',
				lastMonth: '最近一个月',
				lastYear: '最近一年'
			}
		}
	},
	tableColumns: {
		settlementTime: '结算时间',
		transactionTime: '交易时间',
		transactionComTime: '交易完成时间',
		transactionID: '交易流水号',
		orderId: '网站订单号',
		gatewayFlowID: '网关流水号',
		website: '网站',
		groupName: '群组',
		currency: '交易币种',
		amount: '交易金额',
		refundAmount: '退款金额',
		settlementCurrency: '结算币种',
		settlementExchangeRate: '结算汇率',
		settlementAmount: '结算金额',
		deposit: '保证金',
		transactionFee: '交易手续费',
		refundFee: '退款手续费'
	},
	detail: {
		title: '交易查询',
		refundTitle: '退款查询',
		group: '群组',
		store: '门店',
		storeName: '网站',
		omniWebsiteStore: '网站/门店',
		status: '交易状态',
		refundStatus: '退款状态',
		time: '交易时间',
		refundTime: '退款时间',
		startTime: '开始时间',
		endTime: '结束时间',
		orderId: '网站订单号',
		omniOrderId: '商户订单号',
		refundOrderId: '网站退款流水号',
		omniRefundOrderId: '商户退款流水号',
		originTransactionId: '原交易订单号',
		merchantTransactionId: '网站订单号',
		omniMerchantTransactionId: '商户订单号',

		transactionID: '交易流水号',
		shopifyOrderId: 'Shopify 订单号',
		refundTransactionID: '退款流水号',
		search: '查询',
		clear: '重置',
		detail: '查看详情',
		enabled: '成功',
		disabled: '失败',
		export: '导出结果',
		advancedFilter: '高级筛选',
		orderIdTransactionID: '网站订单号/交易流水号',
		omniOrderIdTransactionID: '商户订单号/交易流水号',
		orderIdRefundID: '网站退款流水号/退款流水号',
		omniOrderIdRefundID: '商户退款流水号/退款流水号',
		consumer: '邮箱/手机号',
		groupStore: '网站/群组',
		omniGroupStore: '门店/网站/群组',
		outFlowId: '交易流水号',
		transactionId: '交易订单号',
		transactionMode: '交易模式',
		cardNo: '脱敏卡号',
		cardTipText: '脱敏卡号仅支持通过卡号前六位及后四位进行交易查询。',
		cardNoError: '请输入卡号前六位及后四位进行查询。'
	},
	invoice: {
		invoice: '月发票',
		desc: '我们将在每月1日生成上个月的发票。',
		pickerMonth: '选择月',
		fileName: '文件名称',
		month: '月份',
		operator: '操作',
		download: '下载',
		create: '文件生成中',
		fail: '文件生成失败'
	},
	statementDownload: {
		statementDownload: '对账单下载',
		time: '结算时间：',
		omniTime: '交易日期：',
		startTime: '开始时间',
		endTime: '结束时间',
		fileName: '文件名称',
		type: '类型',
		tableTime: '结算时间',
		omniTableTime: '交易日期',
		omniSettlementDate: '结算日期',

		action: '操作',
		bill: '对账单',
		date: '日对账单',
		week: '周对账单',
		month: '月对账单',
		custom: '自定义对账单',
		confirm: '生成下载',
		transactionReport: '交易对账单',
		settlementReport: '资金对账单',
		disputeReport: '争议对账单',
		customReport: '自定义对账单',
		useTemplate: '使用模版',
		batchDownload: '批量下载',
		tip1: '已经生成过所选日期对应的对账单，请勿重复生成',
		tip2: '%{date} 的对账单正在生成中，请您耐心等候'
	},
	statementSetting: {
		title: '对账单设置',
		fieldSetting: '对账单字段设置',
		getMethod: '对账单获取方式: ',
		ppCheckout: '商户后台',
		sftp: 'PingPong SFTP',
		directory: '下载目录',
		tip: '选择SFTP时必填，请联系技术支持添加下载目录，并配置到此处',
		validTip: '请输入SFTP下载目录',
		format: '对账单格式:',
		rate: '对账单生成频次:',
		date: '日',
		week: '周',
		month: '月',
		templateName: '模版名称',
		delTemplate: '删除模版',
		fieldName: '字段名称',
		customTemplate: '自定义对账单模版',
		delTip: '确定删除“%{title}“吗？',
		delTitle: '删除对账单模板',
		delConfirm: '确定',
		delCancel: '取消',
		delSuccsee: '删除成功!',
		delCanceled: '已取消删除',
		save: '保存设置',
		cancel: '取消修改'
	}
}

export default zh
